import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFButton, VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { LottieTypes } from '@vfgroup-oneplatform/foundation/Components/VFLottieView';

import { PaymentLottie } from '../../../Payment';

import styles from './ResultModal.styles';

const ResultModal = ({
  containerStyle,
  iconAndTextContainerStyle,
  source,
  iconStyle,
  autoPlay,
  loop,
  isLoadingSuccessful,
  mainTitle,
  mainTitleStyle,
  subTitle,
  subTitlePLaceholders,
  subTitleStyle,
  failureIcon,
  failureIconStyle,
  firstButtonType,
  firstButtonTitle,
  handleFirstButtonPress,
  firstButtonStyle,
  firstButtonTextStyle,
  withSecondButton,
  secondButtonType,
  secondButtonTitle,
  handleSecondButtonPress,
  secondButtonStyle,
  secondButtonTextStyle,
  modalHeight,
  theme,
}) => (
  <View style={[styles.doneLoadingContainer(modalHeight), containerStyle]}>
    <View style={[styles.tickAndMessageContainer, iconAndTextContainerStyle]}>
      {isLoadingSuccessful ? (
        <PaymentLottie
          isPaymentRequest={false}
          type={LottieTypes.tick}
          style={[styles.tickIcon, iconStyle]}
          autoPlay={autoPlay}
          loop={loop}
        />
      ) : (
        <Icon name={failureIcon} type="image" style={[styles.icon, failureIconStyle]} />
      )}
      <VFText style={[styles.doneLoadingMainTitle(theme), mainTitleStyle]} i18nKey={mainTitle} />
      <VFText
        style={[styles.doneLoadingSubTitle(theme), subTitleStyle]}
        i18nKey={subTitle}
        placeHolders={subTitlePLaceholders}
      />
    </View>
    <View>
      <VFButton
        type={firstButtonType}
        title={firstButtonTitle}
        onPress={handleFirstButtonPress}
        style={[styles.doneLoadingReturnButton, firstButtonStyle]}
        textStyle={[styles.doneLoadingReturnButtonText, firstButtonTextStyle]}
      />
      {withSecondButton ? (
        <VFButton
          type={secondButtonType}
          title={secondButtonTitle}
          onPress={handleSecondButtonPress}
          style={[styles.doneLoadingReturnButton, styles.secondButtonStyle, secondButtonStyle]}
          textStyle={[styles.doneLoadingReturnButtonText, secondButtonTextStyle]}
        />
      ) : null}
    </View>
  </View>
);

ResultModal.defaultProps = {
  autoPlay: true,
  loop: false,
};

ResultModal.propTypes = {
  modalHeight: PropTypes.number,
  containerStyle: ViewPropTypes.style,
  iconAndTextContainerStyle: ViewPropTypes.style,
  source: PropTypes.object,
  iconStyle: ViewPropTypes.style,
  autoPlay: PropTypes.bool,
  loop: PropTypes.bool,
  isLoadingSuccessful: PropTypes.bool,
  mainTitle: PropTypes.string,
  mainTitleStyle: TextPropTypes.style,
  subTitle: PropTypes.string,
  subTitlePLaceholders: PropTypes.array,
  subTitleStyle: TextPropTypes.style,
  failureIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  failureIconStyle: ViewPropTypes.style,
  firstButtonType: PropTypes.string,
  firstButtonTitle: PropTypes.string,
  handleFirstButtonPress: PropTypes.func,
  firstButtonStyle: ViewPropTypes.style,
  firstButtonTextStyle: TextPropTypes.style,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  withSecondButton: PropTypes.bool,
  secondButtonType: PropTypes.string,
  secondButtonTitle: PropTypes.string,
  handleSecondButtonPress: PropTypes.func,
  secondButtonStyle: ViewPropTypes.style,
  secondButtonTextStyle: TextPropTypes.style,
};

export default withTheme(ResultModal);
